import page from '../../../components/page'
import {store} from "../../../store/store";
import {api,imgPath} from "../../../common/config";
import {ajaxUtil} from "../../../common/AjaxUtil";
import {CommonUtil} from "../../../common/CommonUtil";

export default {
    name: 'apply',
    data() {
        return {
            isPay: false,//取消预约弹出框
            applyInfo: [],
            idCard: store.func.getUserIdCard(),
            totalPage: 1,
            imgError: store.imgError,
            libBookId: 0,
            pageNo: 1,
            pageCount: 4,
            libCode: '',
            readerId: store.user.readerId,
            isbn: '',
            belongLibrary:'',
            id:'',
          imgPath:imgPath
        }
    },
    components: {
        page
    },
    watch: {
        $route() {
            this.getList();
        }
    },
    beforeMount() {
        store.personal._this.activeNav = "预约/报名";
        store.applicant._this.navName="预约";
        this.libCode = this.$route.query.libCode || this.$route.query.hallCode || store.library.hallCode || '';
        this.getList();
    },
    methods: {
        getList() {
            this.pageNo = this.$route.query.page || 1;
            var url = api.reservation.list.replace('{pageNo}', this.pageNo).replace('{pageCount}',this.pageCount)
                .replace('{idCard}', this.idCard) + "&nonceStr=" + (new Date());
                console.log("apply")
            ajaxUtil.ajaxJson(url, null, "GET", (data) => {
                if (data.resultList != null) {
                    this.applyInfo =data.resultList;
                }
                this.totalPage = data.totalPage;
            }, null, this);
        },
        //翻页操作
        pageChange(pageNo) {
            CommonUtil.mergeQuery(this, {page: pageNo});
        },
        /*取消预约弹出框*/
        cancel(isbn,libCode,id) {
            this.isbn = isbn;
            this.libCode = libCode;
            this.id = id;
            this.isPay = true;
        },
        onCancel(status) {
            this.isPay = false;
            if (status == 0) {
                return;
            }
            var url = api.reservation.appointByBackstage;
            var submitData = {
                appointType: 0,
                libCode: this.libCode,
                readerId: this.readerId,
                isbn: this.isbn,
                id: this.id,
            };
            ajaxUtil.ajaxJson(url, submitData, 'POST', (data) => {
                this.getList();
            }, (result) => {
                CommonUtil.setInfo("取消预约失败，请稍后重试!");
            }, this);

        }
    }
}
